module.exports = __webpack_public_path__ + "img/Flag_of_Sweden.87a8f583.svg";